<template>
    <IpHeader
        class="text-[14px]"
        :headerService="headerService"
        fullWidth
        @getStarted="openLogin"
    >
        <template #menus>
            <HeaderMenu />
        </template>
    </IpHeader>
</template>

<script setup lang="ts">
import { IpHeader } from '@patsnap-biz/ip-nav';
import { headerService } from '@/services/header';
import HeaderMenu from './HeaderMenu.vue';
import { useLoginSdk } from '@/composables/useLoginSdk';
import { EMPOWER_TYPE, CHANNEL_SOURCE } from '@eureka/shared/src/login-sdk';
import { i18n } from '@/i18n';
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();

const { openLoginDialog } = useLoginSdk(i18n, {
    from_page: EMPOWER_TYPE.AIR_HOME,
    channel_source: CHANNEL_SOURCE.AIR_EUREKA,
});

function openLogin() {
    openLoginDialog(false);
}
</script>

<style>
.eureka-ip-header {
    border-bottom: 1px solid #e5e7eb;
}
</style>
